import React, { useContext } from 'react';
import { ThemeProvider } from 'emotion-theming';
import {
  Theme,
  ThemeContext,
  genThemedStyled,
} from '@ordermentum/ui-shared/utilities/theme';
import RightSideContent from '@ordermentum/ui-shared/templates/SignupFlowTemplate/components/RightSideContent';
import { ColorCodes, colorsForTheme } from '@ordermentum/ui-shared/foundations';
import { MEDIA_QUERIES as M } from '@ordermentum/ui-shared/foundations/grid';
import { FUTURO_TYPEFACES as F } from '@ordermentum/ui-shared/foundations/font';
import S from '@ordermentum/ui-shared/foundations/size';
import Animation from '@ordermentum/ui-shared/foundations/Animations';
import { Content } from './styles';

type themeStyles = {
  color: ColorCodes;
};

const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  const colorThemes = {
    color: colors.SPACE,
  };
  return colorThemes;
};

const ThemeStyled = genThemedStyled<themeStyles>();

const EmailContent = ThemeStyled(Content)({
  textAlign: 'center',
  [M.TABLET_PORTRAIT_AND_SMALLER]: {
    height: 'calc(100vh - 42vh)',
  },
});

const Text = ThemeStyled.h4(
  p => ({
    margin: 'auto',
    color: p.theme.color,
  }),
  F.H4
);

const Description = ThemeStyled.p(
  p => ({
    marginTop: S.S,
    padding: 0,
    color: p.theme.color,
  }),
  F.BODY
);

const AnimationContainer = ThemeStyled.div({
  margin: `${S.L} 0`,
});

const VerifyEmailPage = () => {
  const theme = getTheme(useContext(ThemeContext));

  return (
    <ThemeProvider theme={theme}>
      <RightSideContent heading="Setting up your connection">
        <EmailContent>
          <AnimationContainer>
            <Animation name="email" />
          </AnimationContainer>
          <Text>Verify your email</Text>
          <Description>
            You&apos;re one step away from placing orders! <br /> <br />
            We sent you an email which contains a link to verify your email
            address to complete your account. Please also check your spam
            folder.
          </Description>
        </EmailContent>
      </RightSideContent>
    </ThemeProvider>
  );
};

export default VerifyEmailPage;
